import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SiteWorkOrdersService } from 'app/_services/site-work-orders.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'add-documents',
  templateUrl: './add-documents.component.html',
})
export class AddDocumentsComponent implements OnInit {
  @ViewChild('fileInput', { static: true }) fileInput;
  @Input() workOrder: any;

  public selectedRamsFiles = [];
  public isLoading = false;

  constructor(
    private activeModal: NgbActiveModal,
    private workOrderService: SiteWorkOrdersService,
  ) { }

  ngOnInit() {
    this.fileInput.nativeElement.click();
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public onFileChange(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      this.selectedRamsFiles.push(file);
    }

    event.target.value = '';
  }

  public viewSelectedDocument(file) {
    const fileUrl = URL.createObjectURL(file);
    window.open(fileUrl, '_blank');
    window.setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
  }

  public removeSelectedDocument(index: number) {
    this.selectedRamsFiles.splice(index, 1);
  }

  public onSubmit() {
    const body = {
      id: this.workOrder.id,
      ramsArray: this.selectedRamsFiles,
    };

    this.isLoading = true;

    this.workOrderService.addRamsToWorkOrder(body).subscribe(() => {
      this.isLoading = false;

      Swal.fire('Uploaded!', 'Additional RAMS documents have been uploaded.', 'success');
      this.activeModal.close('refresh');
    }, (error: any) => {
      this.isLoading = false;
      this.activeModal.close();
      throw error;
    });
  }
}
